import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { createSpareDomain } from "../../store/ducks/spareDomain/actions";
import { formValidation } from "../../hoc/Shared/utility";
import Swal from "sweetalert2";
import Button from "../../components/Button/Button";
import ValidationError from "../../components/ValidationError/ValidationError";
import StringInput from "../../components/Input/StringInput/StringInput";
import Select from "../../components/Input/Select/Select";
// import Skeleton from "react-loading-skeleton";

class SpareDomainCreate extends Component {
    constructor(props){
        super(props);
        this.state = {
            domain: '',
            is_deposit: '',
            touched: false,
            error_message: [],
            loading: true
        }
        this.changeInputHandler = this.changeInputHandler.bind(this);
    }

    componentDidMount(){
        formValidation("spare_domain_form");
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.spare_domain_create !== undefined && nextProps.spare_domain_create !== this.props.spare_domain_create){
            if(nextProps.spare_domain_create.responseCode === 200 && nextProps.spare_domain_create.msgType === 'success'){
                this.setState({ touched: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-saved"),
                    icon: nextProps.spare_domain_create.msgType,
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.props.refreshHandler();
                        this.props.changePageHandler("listing");
                    }
                });
            }
            else {
                this.setState({
                    touched: true,
                    error_message: nextProps.spare_domain_create.message,
                });
                Swal.close();
            }
        }

        return true;
    }

    createSpareDomainHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.confirm"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.domain = this.state.domain;
                data.is_deposit = this.state.is_deposit;
                this.props.createSpareDomain(data);
            }
        });
    }

    changeInputHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render(){
        const { t } = this.props;

        let status_option = [
            { label: t("global.select"), value: "", selected: true },
            { label: t("spare-domain.deposit"), value: 1 },
            { label: t("spare-domain.non-deposit"), value: 0 },
        ];

        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("spare-domain.spare-domain")}</h4>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("spare-domain.new-spare-domain")}</h4>
                            </div>
                            <div className="card-body pt-0">
                                <form method="post" id="spare_domain_form" className="form-horizontal" onSubmit={this.createSpareDomainHandler} noValidate>
                                    <ValidationError formName="spare_domain_form" touched={this.state.touched} message={this.state.error_message} />
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="amount">{t("spare-domain.domain")}</label>
                                                <StringInput
                                                    id="domain"
                                                    name="domain"
                                                    type="text"
                                                    value={this.state.domain}
                                                    onChange={this.changeInputHandler}
                                                    className="form-control filter-input"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className='form-group'>
                                                <label>{t('spare-domain.type')}</label>
                                                <Select
                                                    id='is_deposit'
                                                    name='is_deposit'
                                                    className='form-control'
                                                    getOptionValue='value'
                                                    getOptionLabel='label'
                                                    options={status_option}
                                                    onChange={this.changeInputHandler}
                                                    value={this.state.is_deposit}
                                                    emptyValue={true}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group mb-0 mt-3 justify-content-end">
                                        <div>
                                            <Button typeButton="submit" classValue="btn btn-blue" idValue="submit" buttonName={t("global.save")} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser.data,
        spare_domain_create: state.spareDomain.spare_domain_create
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createSpareDomain: (data) => dispatch(createSpareDomain(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(SpareDomainCreate));